<div
  [formGroup]="form"
  class="flex justify-between gap-4 py-2 px-6 items-center"
>
  <mat-form-field class="input-tg mt-message-input w-2/5" appearance="outline">
    <mat-label>Nome</mat-label>
    <input matInput formControlName="nome" />
  </mat-form-field>
  <mat-form-field class="input-tg mt-message-input w-2/5" appearance="outline">
    <mat-label>Contato</mat-label>
    <input matInput formControlName="contato" mask="(99) 99999-9999" />
  </mat-form-field>
  <button
    mat-flat-button
    class="btn-tg w-1/5"
    [disabled]="form.invalid || loading"
    (click)="createItem()"
  >
    @if (loading) {
      <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
    } @else {
      Adicionar Novo
    }
  </button>
</div>
